import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Facebook } from 'lucide-react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
              <img src="/images/logo.png" alt="Tails and Tweed" className="footer__logo" />
              <p className="footer__tagline">
                Luxury dog and cat grooming salon and professional grooming
                academy in Abingdon, Oxfordshire.
              </p>
              <div className="footer__social">
                <a href="https://www.facebook.com/tailsandtweedgrooming/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <Facebook size={20} />
                </a>
              </div>
            </div>

            <div className="footer__links">
              <h4 className="footer__heading">Quick Links</h4>
              <Link to="/">Home</Link>
              <Link to="/services">Dog Grooming</Link>
              <Link to="/cat-grooming">Cat Grooming</Link>
              <Link to="/spa-experiences">Spa Experiences</Link>
              <Link to="/training">Training Academy</Link>
              <Link to="/team">Our Team</Link>
              <Link to="/contact">Contact</Link>
            </div>

            <div className="footer__links">
              <h4 className="footer__heading">Services</h4>
              <Link to="/services">Full Grooming</Link>
              <Link to="/services">Bath &amp; Brush</Link>
              <Link to="/services">Puppy Grooming</Link>
              <Link to="/services">Hand Stripping</Link>
              <Link to="/cat-grooming">Cat Grooming</Link>
              <Link to="/spa-experiences">Spa Treatments</Link>
            </div>

            <div className="footer__contact">
              <h4 className="footer__heading">Get in Touch</h4>
              <div className="footer__contact-item">
                <MapPin size={16} />
                <span>4b East St. Helens Street,<br />Abingdon, Oxfordshire OX14 5EA</span>
              </div>
              <div className="footer__contact-item">
                <Phone size={16} />
                <a href="tel:07904813567">07904 813567</a>
              </div>
              <div className="footer__contact-item">
                <Mail size={16} />
                <a href="mailto:tweedsdoggrooming@gmail.com">tweedsdoggrooming@gmail.com</a>
              </div>
              <div className="footer__contact-item">
                <Clock size={16} />
                <span>Mon - Sat: By Appointment</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} Tails and Tweed Pet Grooming Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
